export const EMITTER_CREATURE_MERGE_TRAIL = {
    addAtBack: true,
    autoUpdate: true,
    emit: false,
    frequency: 0.1,
    emitterLifetime: 0.1,
    spawnChance: 1,
    particlesPerWave: 1,
    maxParticles: 100,
    lifetime: {min: 0.4, max: 0.4},
    pos: {x: 0, y: 0},
    behaviors: [
        {type: 'textureSingle', config: {texture: "particles/smoke"}},
        {type: 'colorStatic', config: {color: '#FFFF99'}},
        {type: 'scale', config: {scale: {list: [{value: 0.07, time: 0}, {value: 0, time: 1}]}}},
        {type: 'alpha', config: {alpha: {list: [{value: 0.5, time: 0}, {value: 0, time: 1}]}}},
    ],
};

export const EMITTER_CREATURE_MERGE = {
    addAtBack: true,
    autoUpdate: true,
    emit: false,
    frequency: 0.01,
    emitterLifetime: 0.1,
    spawnChance: 1,
    particlesPerWave: 10,
    maxParticles: 20,
    lifetime: {min: 0.5, max: 0.7},
    pos: {x: 0, y: 0},
    behaviors: [
        {type: 'textureSingle', config: {texture: "particles/star"}},
        {type: 'colorStatic', config: {color: '#FFFF00'}},
        {type: 'scaleStatic', config: {min: 0.1, max: 0.1}},
        {type: 'moveSpeed', config: {speed: {list: [{value: 150, time: 0}, {value: 30, time: 1}]}}},
        {type: 'alpha', config: {alpha: {list: [{value: 1, time: 0}, {value: 0.5, time: 1}]}}},
        {type: "rotation", config: {minStart: 0, maxStart: 360, minSpeed: 30, maxSpeed: 45, accel: 20}},
        {type: "moveAcceleration", config: {accel: {x: 0, y: 100}, minStart: 10, maxStart: 10, rotate: false}},
        {type: 'trail', config: EMITTER_CREATURE_MERGE_TRAIL},
    ],
};
